import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { PhasrMonitoredRulesController } from '../controller/PhasrMonitoredRulesController';

export class PhasrMonitoredRulesWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PhasrMonitoredRulesController,
    });
  }
}